export const certifications = [
    {
        id: 29,
        title: "Software Development Engineering Intern",
        issuer: "Yellow.ai",
        date: "2025 (3 Months)",
        description: "Engineered custom JSON action nodes and configured critical conversational data flows within the cloud.yellow.ai ecosystem to streamline platform integrations and logic routing.",
        skills: ["Cloud Integration", "JSON", "Platform Logic", "Data Flows"],
        credentialId: "",
        icon: "fas fa-cloud"
    },
    {
        id: 26,
        title: "Google Analytics Certification",
        issuer: "Google Digital Academy (Skillshop)",
        date: "Oct 2025 - Oct 2026",
        description: "Certification in Google Analytics, covering data tracking and reporting.",
        skills: ["Google Analytics", "Data Tracking", "Reporting"],
        credentialId: "163896475",
        icon: "fab fa-google"
    },
    {
        id: 25,
        title: "Software Development Engineer Intern",
        issuer: "Bluestock",
        date: "June - July 2025",
        description: "2-month software development engineer internship focusing on software development, testing, and debugging. Applied advanced analytical techniques to real-world business problems.",
        skills: ["Software Development", "Testing", "Debugging", "Programming"],
        credentialId: "",
        icon: "fas fa-chart-line"
    },
    {
        id: 24,
        title: "Graphics & Web Design Intern",
        issuer: "Unnati Informatics LLP",
        date: "June - July 2025",
        description: "Full-time internship focused on graphics designing and website layout design. Demonstrated skills in HTML, CSS, and UI/UX principles.",
        skills: ["HTML", "CSS", "Website Design", "Graphics Design"],
        credentialId: "",
        icon: "fas fa-paint-brush"
    },
    {
        id: 23,
        title: "Machine Learning Intern",
        issuer: "GrowthLink",
        date: "April 2025",
        description: "1-month machine learning internship focused on data analysis, demonstrating strong analytical and technical skills.",
        skills: ["Data Analysis", "Machine Learning Algorithms"],
        credentialId: "GWLKC312100",
        icon: "fas fa-chart-line"
    },
    {
        id: 22,
        title: "Deloitte - Data Analytics Job Simulation",
        issuer: "Forage",
        date: "April 2025",
        description: "Data analytics simulation covering statistical testing, data validation, and commercial thinking.",
        skills: ["Data Analysis", "Forensic Technology"],
        credentialId: "LcrkHXjdyFjjadYc4",
        icon: "fas fa-chart-line"
    },
    {
        id: 21,
        title: "Transform your business with Microsoft AI",
        issuer: "Microsoft AI",
        date: "April 2025",
        description: "Certification in Microsoft AI, covering AI fundamentals and applications.",
        skills: ["Artificial Intelligence", "Machine Learning"],
        credentialId: "",
        icon: "fas fa-brain"
    },
    {
        id: 20,
        title: "Artificial Intelligence and Machine Learning Program (ICTRD)",
        issuer: "Indian Council for Technical Research and Development",
        date: "April 2025",
        description: "Developed skills in AI/ML principles and applications.",
        skills: ["Machine Learning", "Artificial Intelligence"],
        credentialId: "DI/C/25004162",
        icon: "fas fa-robot"
    },
    {
        id: 19,
        title: "Quantium - Data Analytics Job Simulation",
        issuer: "Forage",
        date: "Mar 2025",
        description: "Data analytics simulation covering statistical testing, data validation, and commercial thinking.",
        skills: ["Statistical Testing", "Data Validation", "Data Visualization", "Data Wrangling"],
        credentialId: "zEXm9wTe8DYduM335",
        icon: "fas fa-chart-line"
    },
    {
        id: 18,
        title: "Career Essentials in Generative AI",
        issuer: "Microsoft and LinkedIn",
        date: "Feb 2025",
        description: "Certification covering generative AI fundamentals and computer ethics.",
        skills: ["Artificial Intelligence (AI)", "Computer Ethics"],
        credentialId: "",
        icon: "fas fa-robot"
    },
    {
        id: 17,
        title: "Certified in Power BI for Beginners",
        issuer: "Simplilearn",
        date: "Jan 2025",
        description: "Fundamental training in Power BI for data visualization and analysis.",
        skills: ["Power BI"],
        credentialId: "7744591",
        icon: "fas fa-chart-pie"
    },
    {
        id: 16,
        title: "What Is Generative AI?",
        issuer: "Birdify - LMSAFP",
        date: "Jan 2025",
        description: "Introductory course on generative AI and its applications.",
        skills: ["Generative AI"],
        credentialId: "",
        icon: "fas fa-brain"
    },
    {
        id: 15,
        title: "Data Analyst Intern",
        issuer: "Unified Mentor",
        date: "Oct 2024",
        description: "3-month internship in data analytics, focusing on data visualization using Tableau.",
        skills: ["Data Analysis", "Tableau"],
        credentialId: "U85500HR2023PTC115118",
        icon: "fas fa-database"
    },
    {
        id: 27,
        title: "UI/UX Designing",
        issuer: "Vital Skills/IIT Kanpur",
        date: "Aug 2024",
        description: "Comprehensive course in UI/UX design principles and tools.",
        skills: ["UI/UX Design", "Figma", "User-Centric Design"],
        credentialId: "",
        icon: "fas fa-paint-brush"
    },
    {
        id: 14,
        title: "British Airways - Data Science Job Simulation",
        issuer: "Forage",
        date: "Jul 2024",
        description: "Simulation focusing on data science applications in the airline industry.",
        skills: ["Data Science"],
        credentialId: "9mZjFpryxg9KqdTRQ",
        icon: "fas fa-plane"
    },
    {
        id: 13,
        title: "Goldman Sachs - Excel Skills for Business Job Simulation",
        issuer: "Forage",
        date: "Jul 2024",
        description: "Simulation covering business-oriented Excel skills, assumptions, and charting.",
        skills: ["Microsoft Excel", "Charting"],
        credentialId: "CtAFKaj4kurm4jTRm",
        icon: "fas fa-table"
    },
    {
        id: 12,
        title: "Accenture North America - Data Analytics and Visualization Job Simulation",
        issuer: "Forage",
        date: "Jun 2024",
        description: "Data analytics and visualization simulation covering data modeling, analysis, and project planning.",
        skills: ["Data Modeling", "Data Visualization"],
        credentialId: "zr3zDNbmwPYRiqPdz",
        icon: "fas fa-chart-bar"
    },
    {
        id: 11,
        title: "Basics of Project Management",
        issuer: "International Business Management Institute (IBMI)",
        date: "Jun 2024",
        description: "Certification covering fundamental principles of project planning and management.",
        skills: ["Project Management"],
        credentialId: "1221818-171-879-5091",
        icon: "fas fa-tasks"
    },
    {
        id: 10,
        title: "Tata Group - Data Visualisation Job Simulation",
        issuer: "Forage",
        date: "Jun 2024",
        description: "Simulation covering data cleanup, visualization, and business insights.",
        skills: ["Data Visualization"],
        credentialId: "TASinjoGfnQXyag2m",
        icon: "fas fa-chart-area"
    },
    {
        id: 9,
        title: "Walmart USA - Advanced Software Engineering Job Simulation",
        issuer: "Forage",
        date: "Jun 2024",
        description: "Software engineering simulation covering database design, UML, SQL, and data structures.",
        skills: ["SQL", "UML", "Data Structures"],
        credentialId: "nzBqDrXq94ps4gA6Q",
        icon: "fas fa-code-branch"
    },
    {
        id: 28,
        title: "ML Summer Internship",
        issuer: "Techgyan",
        date: "2024",
        description: "Summer internship focusing on Machine Learning principles and practical applications.",
        skills: ["Machine Learning", "Python"],
        credentialId: "",
        icon: "fas fa-robot"
    },
    {
        id: 8,
        title: "Introduction to Large Language Models",
        issuer: "Google Cloud Skills Boost",
        date: "Apr 2024",
        description: "Introductory course on large language models and AI applications.",
        skills: ["LLMs"],
        credentialId: "",
        icon: "fas fa-language"
    },
    {
        id: 7,
        title: "Introduction to Responsible AI",
        issuer: "Google Cloud Skills Boost",
        date: "Mar 2024",
        description: "Course covering ethical considerations and responsible AI development.",
        skills: ["Responsible AI"],
        credentialId: "8271086",
        icon: "fas fa-shield-alt"
    },
    {
        id: 6,
        title: "Introduction to Blockchain",
        issuer: "Amazon Web Services (AWS)",
        date: "March 2024",
        description: "Foundational certification covering blockchain concepts and applications.",
        skills: ["Blockchain"],
        credentialId: null,
        icon: "fab fa-aws"
    },
    {
        id: 5,
        title: "Introduction to Deep Learning",
        issuer: "Amazon Web Services (AWS)",
        date: "March 2024",
        description: "Comprehensive certification covering deep learning concepts and applications.",
        skills: ["Deep Learning"],
        credentialId: null,
        icon: "fas fa-brain"
    },
    {
        id: 4,
        title: "Machine Learning Terminology and Processes",
        issuer: "Amazon Web Services (AWS)",
        date: "March 2024",
        description: "Comprehensive certification covering machine learning terminology and processes.",
        skills: ["Machine Learning"],
        credentialId: null,
        icon: "fas fa-cogs"
    },
    {
        id: 3,
        title: "Foundations of Prompt Engineering",
        issuer: "Amazon Web Services (AWS)",
        date: "March 2024",
        description: "Comprehensive certification covering prompt engineering concepts and applications.",
        skills: ["Prompt Engineering"],
        credentialId: null,
        icon: "fas fa-comments"
    },
    {
        id: 2,
        title: "Introduction to Machine Learning: Art of Possible",
        issuer: "Amazon Web Services (AWS)",
        date: "March 2024",
        description: "Comprehensive certification covering machine learning concepts and applications.",
        skills: ["Machine Learning"],
        credentialId: null,
        icon: "fas fa-cogs"
    }
];
